import { useEffect, useState } from 'react';

// Sign-in comes from Clerk, which loads from clerk.jarvistravel.com on every
// launch and isn't cached by the service worker. Slow or offline, it may not
// load at all, and a screen waiting on it used to wait without a word
// (JAR-2493). Past this, the screen says it can't reach sign-in.
export const CLERK_STALL_MS = 8_000;

/** True once `loaded` has stayed false for CLERK_STALL_MS, and false again once it loads. */
export function useClerkStalled(loaded: boolean): boolean {
  const [stalled, setStalled] = useState(false);
  useEffect(() => {
    if (loaded) return;
    const timer = setTimeout(() => setStalled(true), CLERK_STALL_MS);
    // Each wait clears its own stall as it ends, so a later wait starts from zero.
    return () => {
      clearTimeout(timer);
      setStalled(false);
    };
  }, [loaded]);
  return stalled && !loaded;
}
